import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormInput
} from '@coreui/react-pro'

const FormNumberInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  value,
  handleChange,
  feedbackInvalid,
  invalid,
  disabled,
  max,
  min
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      )}
      <CFormInput
        type="number"
        id={id}
        name={name}
        value={value}
        onChange={(e) => handleChange(e)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        disabled={disabled}
        max={max}
        min={min}
      />
    </CCol>
  )
}

export default FormNumberInput